import { makeDataState } from '@/util/dataState';
import type { SurgicalGuideCaseData, SurgicalGuideUserPreferenceData } from '@/stores/surgicalGuide/surgicalGuide.types';

export const initialSurgicalGuideData: SurgicalGuideUserPreferenceData = {
    surgicalApproachId: '',
};

export const initialState = {
    current: { ...initialSurgicalGuideData },
    lastSaved: { ...initialSurgicalGuideData },
    ...makeDataState(),
};

export const initialSurgicalGuideCaseData: SurgicalGuideCaseData = {
    crNumber: '',
    surgicalApproachId: '',
};

export const initialCaseState = {
    current: { ...initialSurgicalGuideCaseData },
    lastSaved: { ...initialSurgicalGuideCaseData },
    ...makeDataState(),
};
